import React from "react";
import '../assets/css/Screen.css'

/* Definiendo un componente como Funcion Flecha */

const Screen = ( { input }) => ( 
  <div className="input">
    {input}
  </div>
);

export default Screen;